import { isUndefined } from 'lodash-es'
import { MMKV } from 'react-native-mmkv'

const kv = new MMKV({
  id: 'app-storage',
})

// MMKV can throw when its backend is unavailable — e.g. the web shim throws
// "Could not find 'localStorage' instance!" inside a restricted WebView. A
// missing storage backend must never crash the app, so every access degrades
// gracefully (reads return null, writes are no-ops).
const storage = {
  get: <T>(key: string): T | null => {
    try {
      const jsonValue = kv.getString(key)
      if (!jsonValue) return null
      return JSON.parse(jsonValue)
    } catch {
      return null
    }
  },
  set: (key: string, value: any) => {
    if (isUndefined(value)) {
      storage.remove(key)
      return
    }
    try {
      kv.set(key, JSON.stringify(value))
    } catch {
      // storage unavailable — drop the write
    }
  },
  remove: (key: string) => {
    try {
      kv.delete(key)
    } catch {
      // storage unavailable — nothing to remove
    }
  },
  clear: () => {
    try {
      kv.clearAll()
    } catch {
      // storage unavailable — nothing to clear
    }
  },
}

export default storage
